// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"a9544c76","630":"c81b2468"}[chunkId] + ".chunk.js";
};